import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import "../stylesheets/detailsForm.css";
import {
  Tooltip,
  OverlayTrigger,
  Row,
  Col,
  Container,
  Modal,
} from "react-bootstrap";
import {
  Combobox,
  DateInput,
  PaginatedSelect,
  TextField,
} from "./layout/form/TextInputFields";
import ModifiedForm from "./layout/form/ModifiedForm";
import {
  getPermCategories,
  getPermJobs,
  searchUpdate,getPaginatedBranches
} from "../api/branchesRequests";
import axiosInstance from "../api/axiosInstance";
import ErrorHandler from "../error-handler/ErrorHandler";
import { Select, Image } from "antd";
import DataTable from "react-data-table-component";
import DeleteModal from "../components/layout/deleteModal";


function ModifiedSelect({ id,selectedBank, returnValue, title, dataFunction, queryTitle }) {
  const [branches, setbranches] = useState([]);
  const [branchesNext, setbranchesNext] = useState(1);

  function initData() {
    dataFunction(selectedBank).then((res) => {
      console.log(res.data);

      setbranches(res.data);
      setbranchesNext(res.next);
    });
  }

  useEffect(() => {
    initData();
  }, []);

  return (
    <PaginatedSelect
      returnValue={returnValue}
      id={id}
      title={title}
      className="formTextField"
      loadNext={() => {
        branchesNext &&
          dataFunction(branchesNext,selectedBank).then((res) => {
            console.log(res);
            setbranches([...branches, ...res.data]);
            setbranchesNext(res.next);
          });
      }}
    >
      {branches &&
        branches?.map((e) => (
          <Select.Option key={e.id} value={e.id}>
            {e[queryTitle]}
          </Select.Option>
        ))}
    </PaginatedSelect>
  );
}
function SearchSignatures(props) {
  const { t } = useTranslation();
  const [searchResults, setSearchResults] = useState([]);
  const [show, setShow] = useState(false);
  const [showDeleteModal , setShowDelete] = useState(false)
  const [signatureID, setID] = useState("");
  const [signature, setSignature] = useState("");
  const [columns, setCoulmns] = useState([
    {
      name: `${t("searchTable.bank")}`,
      selector: (row) => row?.bank.name_en,
      sortable: true,
      right: true,
    },
    {
      name: `${t("searchTable.branch")}`,
      selector: (row) => row?.bank_branch.name_en,
      sortable: true,
      right: true,
    },
    {
      name: `${t("searchTable.englishName")}`,
      selector: (row) => row?.signee_name_en,
      sortable: true,
      right: true,
    },
    {
      name: `${t("searchTable.arabicName")}`,
      selector: (row) => row?.signee_name_ar,
      sortable: true,
      right: true,
    },
    {
      name: `${t("searchTable.job")}`,
      selector: (row) => row?.job.title_en,
      sortable: true,
      right: true,
    },
    {
      name: `${t("form.category")}`,
      selector: (row) => row?.category.title_en,
      sortable: true,
      right: true,
    },
    {
      name: `${t("unverifiedTable.actions")}`,
      button: true,
      cell: (row) => (
        <div className="table-data-feature">
          <OverlayTrigger
            key={"4"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-${"top"}`}>
                {t("searchTable.viewSig")}
              </Tooltip>
            }
          >
            <i
              id={row.id}
              onClick={showModel}
              className="fas fa-user-check pr-2"
            ></i>
          </OverlayTrigger>
          <OverlayTrigger
            key={row.id}
            placement={"top"}
            overlay={<Tooltip id={`tooltip-${"top"}`}>Update Signature</Tooltip>}
          >
            <i
              id={row.id}
              onClick={e =>updateSignature(row.id)}
              className="fas fa-pen pr-2"
            ></i>
          </OverlayTrigger>
          <OverlayTrigger
            key={row.id}
            placement={"top"}
            overlay={<Tooltip id={`tooltip-${"top"}`}>Delete Signature</Tooltip>}
          >
            <i
              id={row.id}
              onClick={id => showDelete(row.id)}
              className="fas fa-trash pr-2"
            ></i>
          </OverlayTrigger>
        </div>
      ),
    },
  ]);
  const updateSignature = (id) =>{
    props.history.push(`/edit_signature/${id}`);
  }
  const closeDelete = (e) => {
    setShowDelete(false);
  };
  
  const showDelete = (id) =>{ 
    setShowDelete(true)
    console.log(id)
    setID(id)
  }
  const showModel = async (e) => {
    let result = await axiosInstance
      .get(`/signature/${e.target.id}`)
      .catch((err) => console.log(err));

    if (result) {
      console.log(result);
      console.log(result.data.image.image);
      setSignature(result.data);
    }
    setShow(true);
  };
  const close = (e) => {
    setShow(false);
  };
  async function submit(data) {
    let result = await searchUpdate(data);
    if (result) {
      console.log(result);
      setSearchResults(result.data.data);
    }
  }

  return (
    <>
      <ModifiedForm submitFunction={submit}>
        <div className="styledform">
          <TextField
            className="formTextField"
            id={"signee_name_ar"}
            title={t("form.nameAR")}
          />
          <TextField
            className="formTextField"
            id={"signee_name_en"}
            title={t("form.nameEN")}
          />
         

         <ModifiedSelect
            id={"bank_branch"}
            title={t("form.branch")}
            dataFunction={getPaginatedBranches}
            queryTitle={"name_en"}
          />
            <ModifiedSelect
              id={"category"}
              title={t("form.category")}
              dataFunction={getPermCategories}
              queryTitle={"title_en"}
            />

            <ModifiedSelect
              id={"job"}
              title={t("form.job")}
              dataFunction={getPermJobs}
              queryTitle={"title_en"}
            />



          <DateInput
            className="formTextField"
            id={"avaliable_from"}
            title={t("form.available")}
          />
        </div>
        <div className="formSubmit">
          <button className="defaultButton" type="submit">
            {t("buttons.finish")}
          </button>
        </div>
      </ModifiedForm>
      <Row>
        <Col style={{ textAlign: "center", marginTop: "20px" }} sm={12}>
          <DataTable
            columns={columns}
            data={searchResults}
            noDataComponent={
              <div style={{ padding: "30px" }}>{t("noData")}</div>
            }
          />
        </Col>
      </Row>
      <Modal size="xl" show={show} onHide={close}>
        <Container className="p-4">
          <Row>
            <Col className="text-center" sm={12}>
              {" "}
              <h2 className="signature-title">{t("searchTable.sigLabel")}</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <div className="signature-data">
                <label className="label">{t("name")} :</label>
                <p>{signature ? signature.data.signee_name_en : null}</p>
              </div>
              <div className="signature-data">
                <label className="label">{t("searchTable.category")} :</label>
                <p>{signature ? signature.data.category.title_en : null}</p>
              </div>
              <div className="signature-data">
                <label className="label">{t("searchTable.privileges")} :</label>
                <p>{signature ? signature.data.category.privs_en : null}</p>
              </div>
              <div className="signature-data">
                <label className="label">{t("searchTable.job")} :</label>
                <p>{signature ? signature.data.job.title_en : null}</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="sigImage">
                <Image src={signature ? signature.image : null} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <div>
                <label className="label">{t("searchTable.bank")} :</label>
                <p>{signature ? signature.data.bank.name_en : null}</p>
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <label className="label">{t("searchTable.branch")} :</label>
                <p>{signature ? signature.data.bank_branch.name_en : null}</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              {signature ? (
                <p>
                  <a href={`/view_instructions/${signature.data.bank.id}`} target="_blank">
                    {t("searchTable.checkInstruction")}
                  </a>
                </p>
              ) : null}
            </Col>
          </Row>
        </Container>
      </Modal>
      <DeleteModal show={showDeleteModal} hide={()=>setShowDelete(false)} cancel={closeDelete} url={`/signature/${signatureID}`}  modalHeader="Are you sure you want to delete this signature?" />

    </>
  );
}

export default ErrorHandler(SearchSignatures, axiosInstance);
